<div class="h-full bg-gradient-to-t from-white via-white to-primary-200">
  <!-- <app-home-navbar></app-home-navbar> -->
  <router-outlet></router-outlet>
</div>
